import PropTypes from 'prop-types';
import React from 'react';
import VIRTUAL_TOURS_IMAGE from 'static/images/show/background-virtual-tours.jpg';

const VenueBlocks = ({ venues }) => {
    const renderVirtualTourBlock = (venue) => (
        // accessibility: avoid double reading the link + button
        <a aria-label="Take a Virtual Tour" className="block-virtual-tour" href={venue.tourLink} style={{ backgroundImage: `url(${VIRTUAL_TOURS_IMAGE})` }}>
            <button aria-hidden="true" tabIndex="-1" className="button secondary inverse || link-label">Take a Virtual Tour</button>
        </a>
    );

    const renderVenueBlock = (venue, key) => (
        <div className="block" key={key}>
            {/* invisible heading for accessibility only */}
            <h2 className="sr-only">Location</h2>
            <div className="block-info">
                <span className="h5 pre-heading">On at</span>
                <a className="venue-link" href={venue.url}>
                    <span className="h4 title">{venue.name}</span>
                </a>
                <p className="address">{venue.location.raw}</p>
            </div>
            {/* accessibility: avoid double reading the link + button */}
            <a className="block-direction" aria-label="Get Directions" href={venue.directionsUrl} rel="noreferrer" style={{ backgroundImage: `url(${venue.map})` }} target="_blank">
                <button aria-hidden="true" tabIndex="-1" className="button secondary inverse || link-label">Get Directions</button>
            </a>

            {venue.tourLink && renderVirtualTourBlock(venue)}
        </div>
    );

    return (
        <section className="content-section || constrain-width">
            <div className="venue-blocks">
                {venues.map((venue, index) => renderVenueBlock(venue, index))}
            </div>
        </section>
    );
};

VenueBlocks.propTypes = {
    venues: PropTypes.array.isRequired
};

export default VenueBlocks;
